/* import __COLOCATED_TEMPLATE__ from './free-seats-checkout-banner.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
}

const FreeSeatsCheckoutBanner = templateOnlyComponent<Signature>();
export default FreeSeatsCheckoutBanner;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Signup::Teams::Pricing5::Components::FreeSeatsCheckoutBanner': typeof FreeSeatsCheckoutBanner;
  }
}
